import React from 'react';
import Layout from '../layouts/two';
import Rules from '../rules';
import TournamentLink from './partials/tournament';
import ScrollAnimation from 'react-animate-on-scroll';
import SubNav from './partials/sub_nav';
import ESPN from './partials/espn';
import _ from 'lodash';

class RulesSection extends React.Component {
    
    state = {}
    
    componentWillMount() {
        const { tournaments, upcoming, past, params, tournamentsActions } = this.props, { id } = params;
        if ((tournaments && tournaments.length && _.find(tournaments, t => parseInt(t.id, 10) === parseInt(id, 10)))) {
            this.setState({ tournament: _.find(tournaments, t => parseInt(t.id, 10) === parseInt(id, 10)) });
        } else if ((upcoming && upcoming.length && _.find(upcoming, t => parseInt(t.id, 10) === parseInt(id, 10)))) {
            this.setState({ tournament: _.find(upcoming, t => parseInt(t.id, 10) === parseInt(id, 10)) });
        } else if ((past && past.length && _.find(past, t => parseInt(t.id, 10) === parseInt(id, 10)))) {
            this.setState({ tournament: _.find(past, t => parseInt(t.id, 10) === parseInt(id, 10)) });
        }
        tournamentsActions.fetch(id);
    }
    componentWillReceiveProps = nextProps => {
        const { tournament } = nextProps;
        this.setState({ tournament });
    }
    
    render() {
        const { params } = this.props, { id } = params, { tournament = {} } = this.state, { Medal = {} } = (tournament || {});
        let bi = (tournament && tournament.IdMedal) ? `/images/medals/${tournament.IdMedal}.jpg` : "/images/backgrounds/edoardo-busti-413350-unsplash.jpg";
        return <Layout medal={Medal} nbs="tournaments" title="RULES" bi={bi}>
            <section>
                <div id="tournament" style={{ marginTop: '-4.5em' }}>
                    <div className="w3-container w3-content">
                        <div className="d-flex flex-column">
                            <ul className="no-margin no-padding" style={{ listStyle: 'none' }}>
                                <ScrollAnimation animateIn="fadeIn" animateOnce={true} component="li"
                                    className="w3-card margin-top" style={{ backgroundColor: 'white', borderRadius: 4 }}>
                                    <TournamentLink hideLink={true} tournament={tournament} /></ScrollAnimation>
                            </ul>
                        </div>
                    </div>
                    {tournament && tournament.id && <div className="w3-container w3-content">
                        <SubNav current={2} id={id} tournament={tournament} />
                        <Rules hideTitle={true} />
                    </div>}
                    {tournament && tournament.IsESPN && <ESPN tournament={tournament} />}
                </div>
            </section>
        </Layout>
    }
}

export default RulesSection;



// WEBPACK FOOTER //
// ./src/components/tournaments/rules.js